<template>
  <div data-component-group="filter-forms" data-component="events-assets">
    <FiltersForm
      has-phone-sheet
      :applied-filters="appliedFilters"
      :on-clear-filter="clearFilter"
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      :is-global-country-filter="false"
    >
      <template v-slot:phone-actions>
        <slot name="phone-actions" />
      </template>

      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="dates"
        placeholder="Created Date"
        :config="dateConfig"
        :on-change="onChangeDate"
      />
    </FiltersForm>
  </div>
</template>

<script>
import FiltersForm from '../FiltersBase';
import { debounce, isNonEmptyStr } from '@/utils';
import filterUrlSync from '@/mixins/filterUrlSync';
import filterChips from '@/mixins/filterChips';
import { v1 as uuidv1 } from 'uuid';

const debouncer = debounce({
  id: uuidv1(),
  timeout: 500
});

export default {
  mixins: [filterUrlSync, filterChips],
  components: {
    FiltersForm,
  },
  data() {
    return {
      urlConfig: [
        { field: 'search', urlKey: 'search', type: 'string' },
        { field: 'dates', urlKey: 'dates', type: 'string' },
      ],
      search: null,
      dates: null,
      dateConfig: {
        mode: 'range',
      },
    };
  },
  computed: {
    hasFilters() {
      const { search, dates } = this;
      return isNonEmptyStr(search) || isNonEmptyStr(dates);
    },
    filterChipFields() {
      return [
        { model: 'search', label: 'Search' },
        { model: 'dates', label: 'Created Date' },
      ];
    },
  },
  emits: ['filter', 'clearFilters'],
  methods: {
    onFilter() {
      const { search, dates } = this;

      this.syncFiltersToUrl();
      this.rememberAppliedFilters();

      this.$emit('filter', {
        search,
        dates,
      });
    },
    onClearFilters() {
      this.search = null;
      this.dates = null;

      this.clearFiltersUrl();
      this.forgetAppliedFilters();

      this.$emit('clearFilters');
    },
    onChangeDate(dates) {
      this.dates = dates;
    },
  },
};
</script>